import React from "react";
import VisibilitySensor from "../VisibilitySensor";
import { makeStyles } from "@material-ui/core/styles";
import Content from "./Content";
import Form from "./Form";
import { mobile } from "../mediaQueries";
import AssignId from "../AssignId";
import { FormConfiguration } from '../../configuration'

const styles = (theme) => ({
  root: {
    cursor: "none !important",

    padding: "100px 20rem",
    display: "flex",
    position: "relative",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.down(theme.breakpoints.values.xs + 1300)]: {
      padding: "100px 10px",
      height: "auto",
      textAlign: "center",
    },
    [theme.breakpoints.down(theme.breakpoints.values.xs + mobile)]: {
      padding: "100px 10px",
      height: "auto",
      textAlign: "center",
    },
  },
});

const useStyles = makeStyles(styles);

export default function FormPage() {
  const classes = useStyles();
  return (
    <div>
      <VisibilitySensor index={9} />
      <div id="formPage" className={classes.root}>
        <AssignId absolute y="-10px" yMobile="0" id={FormConfiguration.slug} />
		<div class="d-none">
        <Content
          primaryText=""
          secondaryText=""
        />
        <Form />
        </div>
      </div>
    </div>
  );
}